import { onError } from '@apollo/client/link/error';
import { getLogger } from '@storefront/logging';
import { GraphQLFormattedError } from 'graphql/error';

const logger = getLogger('apollo-graphql-error-link');

type Listener = (error: GraphQLFormattedError | Error) => void;

const listeners = new Set<Listener>();

export const registerListener = (listener: Listener) => listeners.add(listener);
export const removeListener = (listener: Listener) =>
  listeners.delete(listener);

export const errorLink = onError((error) => {
  if (error.graphQLErrors)
    error.graphQLErrors.forEach((graphQLError) => {
      listeners.forEach((listener) => listener(graphQLError));
      logger.error({
        msg: graphQLError.message,
        location: graphQLError.locations,
        path: graphQLError.path,
      });
    });
  if (error.networkError) {
    listeners.forEach((listener) => listener(error.networkError));
    logger.error({ msg: 'Network error', error: error.networkError.message });
  }
});
